import CenterWrapper from '../shared/CenterWrapper.vue';
export default {
  name: "AnnouncementIconNew",
  components: {
    CenterWrapper
  },
  props: {
    color: {
      type: String,
      default: "#4C8EFF"
    },
    width: {
      type: String,
      default: "16"
    },
    height: {
      type: String,
      default: "16"
    }
  }
};